import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { Pagination } from "element-ui";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import axios from './httpConfig/http'
Vue.prototype.$http = axios

import $ from "jquery";
let base64 = require("js-base64").Base64;
Vue.prototype.$base64 = base64;

Vue.use(ElementUI, { size: "big", zIndex: 3000 });
Vue.use(Pagination)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  $,
  render: h => h(App)
}).$mount("#app");
